module.exports = __webpack_public_path__ + "static/img/ys_role.074696f.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/role3/control/ys_role.png
// module id = Zlb0
// module chunks = 7